import styled, { css } from 'styled-components';

import { type Color, type Variant } from './types';
type BadgeContainerProps = {
    $color?: Color;
    $variant?: Variant;
    $active?: boolean;
};

export const BadgeContainer = styled.span<BadgeContainerProps>`
    &&&& {
        user-select: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border: 0;

        font-family: 'Alliance No.1';
        font-style: normal;
        font-size: 0.75rem;

        letter-spacing: -0.02em;
        padding: 0 0.5em;
        text-overflow: ellipsis;
        white-space: nowrap;

        ${({ $color, $active, theme }) => {
            switch ($color) {
                case 'primary': {
                    return css`
                        color: ${theme.colors.purple};
                        background-color: ${theme.colors.white};
                    `;
                }
                case 'secondary': {
                    return css`
                        color: ${$active ? theme.colors.white : theme.shades.white[50]};
                        background-color: ${$active ? theme.shades.white[10] : theme.shades.white[10]};

                        :active {
                            color: theme.colors;.white;
                            background-color: ${theme.shades.white[10]};
                        }
                    `;
                }
                case 'purple': {
                    return css`
                        color: ${$active ? theme.colors.purple : theme.colors.white};
                        background-color: ${$active ? theme.colors.white : theme.colors.purple};

                        :active {
                            color: theme.colors;.white;
                            background-color: ${theme.colors.purple};
                        }
                    `;
                }
            }
        }}

        ${({ $variant }) => {
            switch ($variant) {
                case 'mini': {
                    return css`
                        border-radius: 1em;
                        font-size: 0.6em;
                        font-weight: 700;
                        padding: 0.2em 0.5em;
                    `;
                }

                case 'small': {
                    return css`
                        border-radius: 1em;
                        font-size: 0.75em;
                        font-weight: 700;
                        height: 1.777777777em;
                        line-height: 1;
                    `;
                }

                case 'round': {
                    return css`
                        border-radius: 0.83333333em;
                        font-weight: 700;
                        height: 1.66666667em;
                        line-height: 1;
                        min-width: 1.66666667em;
                    `;
                }

                case 'default':
                default: {
                    return css`
                        border-radius: 2.5em;
                        font-weight: 500;
                        height: 1.83333333em;
                        line-height: 1.3;
                    `;
                }
            }
        }}
    }
`;
